import { createRouter, createWebHistory } from 'vue-router';
import Home from '@components/Home.vue';
import About from '@components/About.vue';
import Testing from '@components/Testing.vue';
import NotFound from '@environment/NotFound.vue';

// Redirección de las Rutas
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    // ##### Rutas #####
    {
      path: '/',
      name: 'Home',
      component: Home,
    },
    {
      path: '/about',
      name: 'About',
      component: About,
    },
    {
      path: '/testing',
      name: 'Testing',
      component: Testing,
    },
    // ##### 404 #####
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      component: NotFound,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return false;
    }
    return { top: 0 };
  },
});
export default router;
